
import { defineComponent, ref, computed, watch } from 'vue';
import { message } from 'ant-design-vue';
import { OioModal } from '@kunlun/vue-ui-antd';
import { BillingBill, BillingBillOperationLog } from '../types';
import { queryBillingOperationLogs } from '../api/billingBill';
import { billingBillOperationTypeTextMap } from '../constants';

export default defineComponent({
  name: 'OperationLogDialog',
  components: { OioModal },
  props: {
    visible: { type: Boolean, default: false },
    billingBill: { type: Object as () => BillingBill | null, default: null }
  },
  emits: ['update:visible'],
  setup(props, { emit }) {
    const loading = ref(false);
    const logs = ref<BillingBillOperationLog[]>([]);

    const dialogVisible = computed({
      get: () => props.visible,
      set: (val) => emit('update:visible', val)
    });

    const columns = [
      { title: '操作时间', dataIndex: 'createDate', key: 'createDate', width: 170 },
      { title: '操作类型', dataIndex: 'operationType', key: 'operationType', width: 110 },
      { title: '操作人', dataIndex: 'operatorName', key: 'operatorName', width: 120 },
      { title: '描述', dataIndex: 'detail', key: 'detail' }
    ];

    const operationTypeText = (type: string) => billingBillOperationTypeTextMap[type] || type;

    const fetchLogs = async () => {
      if (!props.billingBill) return;
      loading.value = true;
      try {
        const page = await queryBillingOperationLogs(props.billingBill.id);
        logs.value = page.content || [];
      } catch (e: any) {
        message.error(e?.message || '查询操作日志失败');
      } finally {
        loading.value = false;
      }
    };

    const handleClose = () => {
      dialogVisible.value = false;
    };

    watch(
      () => props.visible,
      (val) => {
        if (val) {
          logs.value = [];
          fetchLogs();
        }
      }
    );

    return {
      dialogVisible,
      loading,
      logs,
      columns,
      operationTypeText,
      handleClose
    };
  }
});
